/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('PersonalNavbarController', PersonalNavbarController);

    PersonalNavbarController.$inject = ['PrincipalProfile'];

    function PersonalNavbarController (PrincipalProfile) {
        var vm = this;

        PrincipalProfile.identity(true).then(function(profile) {
            vm.profile = profile;
        });
    }
})();
